<lex-sidenav-container>
  <ng-container left>
    <div></div>

    <!--Employee Search-->
    <div class="employee-search" style="margin-top: 8px; font-size: 15px; height: 75px; align-items: center; display:flex;">
      <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; place-content: stretch space-between; align-items: stretch; gap: 20px;">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row">
          <div mat-line style="width:100%">
            <mat-form-field class="show-no-errors custom-infix-padding" style="padding-left: 16px; padding-right: 16px; width: calc(100% - 10px);">
              <input matInput placeholder="Search" #searchBox id="search-box" (keyup)="onUpdateSearch(searchBox.value)" />
              <button id="clearSearch" *ngIf="searchBox.value" matSuffix mat-icon-button aria-label="Clear" (click)="searchBox.value=''; onUpdateSearch(searchBox.value)">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; place-content: stretch space-between; align-items: stretch; gap: 20px;">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row">
          <div mat-line style="width:100%">
            <mat-form-field class="density-neg-1 show-no-errors" style="padding-left: 16px; padding-right: 16px; width: calc(100% - 32px);" *ngIf="departments">
              <mat-label>Department</mat-label>
              <mat-select (selectionChange)="onUpdateDepartment($event.value)">
                <mat-option>- Clear -</mat-option>
                <mat-option *ngFor="let department of departments" [value]="department.name">
                  <div>{{department.name}}</div>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <cdk-virtual-scroll-viewport #leftScroll itemSize="48" style="height:87%">
      <mat-action-list style="overflow: hidden;" *ngIf="employees$ | async as employees">

        <!---Lexbe Employee List-->
        <button mat-list-item [attr.id]="'selectUserId.'+user.id" *cdkVirtualFor="let user of filterEmployee(employees)" [ngClass]="{'sidenav-selected-item': selectedUser === user, 'sidenav-row-item': selectedUser !== user}" (click)="selectUser(user)">
          <div matListItemIcon>
            <mat-icon class="sidenav-icon-avatar" color="primary">face</mat-icon>
          </div>
          <div matListItemTitle> {{user.userName}} </div>
          <div matListItemLine style="color:grey" *ngIf="user.roles"> {{matchRolesToDepartmentName(user.roles)}} </div>
          <mat-divider></mat-divider>
        </button>
      </mat-action-list>
    </cdk-virtual-scroll-viewport>

    <div></div>
  </ng-container>

  <!--Employee Roles Main Layout main content-->
  <ng-container right>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; gap: 20px;">
      <div></div>
      <div style="display: flex; flex-direction: row; gap: 20px;">
        <div></div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
          <mat-toolbar color="primary" class="toolbar-over-card">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
              <mat-card-title>Employee Roles</mat-card-title>
            </div>
          </mat-toolbar>
          <div style="flex: 1 1 0%; box-sizing: border-box;">
            <mat-card appearance="outlined">
                <div style="font-size: 15px" *ngIf="!selectedUser">
                  No User Selected
                </div>
                <mat-card-content style="margin-bottom: 0px" *ngIf="selectedUser">
                  <form [formGroup]="employeeRolesForm">
                    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
                      <div style="margin: 10px; flex: 1 1 0%; box-sizing: border-box;">
                        <div>
                          <div style="box-sizing: border-box; display: flex; place-content: center flex-start; align-items: center;">
                            <div style="flex: 1 1 60px; box-sizing: border-box; max-width: 60px; min-width: 60px;">
                              <mat-icon class="circle-icon">face</mat-icon>
                            </div>
                            <div style="text-align: left; flex: 1 1 0%; box-sizing: border-box;">{{selectedUser.userName}}</div>
                          </div>
                          <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center;">
                            <mat-form-field style="align-content: flex-end; width:30%" *ngIf="departments">
                              <mat-label>Department</mat-label>
                              <mat-select formControlName="departments" (selectionChange)="changeDepartment($event.value)">
                                <mat-option *ngFor="let department of departments" [value]="department.name">
                                  <div>{{department.name}}</div>
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                        <mat-selection-list formControlName="userRoles" class="list" style="text-align: left;" *ngIf="employeeRoles" (selectionChange)="changeUserRoles($event)">
                          <mat-list-option *ngFor="let role of groupRoles(employeeRoles, 0, 10)" [value]="role.name">
                            <span matListItemTitle style="display: flex; align-items: center;">{{role.name}}</span>
                          </mat-list-option>
                          <mat-divider [inset]="true"></mat-divider>
                          <mat-list-option *ngFor="let role of groupRoles(employeeRoles, 10, 20)" [value]="role.name">
                            <span matListItemTitle style="display: flex; align-items: center;">{{role.name}}</span>                          </mat-list-option>
                          <mat-divider [inset]="true"></mat-divider>
                          <mat-list-option *ngFor="let role of groupRoles(employeeRoles, 20, 30)" [value]="role.name">
                            <span matListItemTitle style="display: flex; align-items: center;">{{role.name}}</span>                          </mat-list-option>
                          <mat-divider [inset]="true"></mat-divider>
                          <mat-list-option *ngFor="let role of groupRoles(employeeRoles, 30, 40)" [value]="role.name">
                            <span matListItemTitle style="display: flex; align-items: center;">{{role.name}}</span>                          </mat-list-option>
                        </mat-selection-list>
                      </div>
                    </div>
                  </form>
                </mat-card-content>
                <mat-card-actions *ngIf="selectedUser">
                  <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-right: 20px;">
                    <button mat-button id="updateEmployeeRolesForm" color="primary" [disabled]="employeeRolesForm.pristine" type="submit" (click)="onSubmit()"> Update</button>
                    <button mat-button id="cancelEmployeeRolesForm" color="primary" [disabled]="employeeRolesForm.pristine" type="button" (click)="onCancel()"> Cancel</button>
                  </div>
                </mat-card-actions>
            </mat-card>
          </div>
        </div>
        <div></div>
      </div>
      <div></div>
    </div>

  </ng-container>
</lex-sidenav-container>
